<div class="ct-container">
  @if (isPizza && pizzaConfig) {
    <div class="ct-main-content">
      <app-order-pizza
        [config]="pizzaConfig"
        [mode]="'delivery'"
        [categoriesInput]="pizzaCategories"
        (onDone)="onPizzaDone($event)"
        (onCancel)="back()">
      </app-order-pizza>
    </div>
  } @else {
  @if (poptionals.length > 0 && adding) {
    <div class="ct-main-content">
      <app-poptionals
        [poptionals]="poptionals"
        (onDone)="done($event)"
        (onCancel)="adding = false"
        [itemQty]="item.quantity">
      </app-poptionals>
    </div>
  }

  @if (!adding) {
    <div class="ct-main-content">
      <div class="p-name">
        {{ item.product.delivery_name || item.product.name }}
        <button class="btn btn-md btn-success btn-cart-add" [disabled]="loadingPoptionals" (click)="addProduct()">
          <fa-icon [icon]="faCartShopping" size="lg"></fa-icon>
          <fa-icon [icon]="faPlus" class="custom-mini"></fa-icon>
        </button>
      </div>
      <div class="p-description">{{ item.product.description }}</div>
      <div class="p-image">
        <img [src]="product.final_picture_path" />
      </div>
      <div class="p-qty">
        <app-qty-button
          [quantity]="item.quantity"
          min="1"
          (change)="item.quantity = $event.value">
        </app-qty-button>
      </div>
      <div class="p-notes">
        <div class="label">Observações</div>
        @for (note of item.notes_obj; track note; let i = $index) {
          <div class="note">
            <input
              type="text"
              name="note-text"
              [(ngModel)]="note.text"
              class="form-control note-input"
              (keydown)="checkEnter($event)" />
            @if (item.notes_obj.length > 1 && i != item.notes_obj.length - 1) {
              <button
                class="btn btn-md btn-danger note-btn"
                (click)="removeNote(i)">
                <fa-icon [icon]="faMinus"></fa-icon>
              </button>
            }
            @if (i == item.notes_obj.length - 1) {
              <button
                class="btn btn-md btn-primary note-btn"
                (click)="addNote()">
                <fa-icon [icon]="faPlus"></fa-icon>
              </button>
            }
          </div>
        }
        <div class="add-note">
        </div>
      </div>
      <div class="p-actions">
        <button class="btn btn-lg btn-secondary" (click)="back()">
          Voltar
        </button>
        &nbsp; &nbsp;
        <button class="btn btn-lg btn-success" [disabled]="loadingPoptionals" (click)="addProduct()">
          Adicionar
        </button>
      </div>
    </div>
  }
  }
</div>